<template>
    <div class="delivery-time-wrapper">
        <component is="style" v-html="useCss ? useCssValue : false"></component>
        <div v-if="$ceres.isShopBuilder || checkAvailibilityID.includes(currentVariation.variation.availability.id) && feiertage.length > 1" class="delivery-time-container" :class="'av_' + currentVariation.variation.availability.id">
            <!-- Frontend -->
            <div :class="'bg-' + appearance" v-if="!$ceres.isShopBuilder" :style="roundedCorners ? { borderRadius: roundedCornersValue + 'px'} : {}">
                <!-- Widget Shipping regular days -->
                <template v-if="countdown > 0 && !sunday && !holiday && currentDay != 6">
                    <div :class="this.$attrs.spacingclasses" v-html="updatedHTML" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
                </template>
                <!-- Widget Shipping for saturdays -->
                <template v-else-if="countdown > 0 && !sunday && !holiday && currentDay == 6 && saturdayWeekday">
                    <div :class="this.$attrs.spacingclasses" v-html="updatedHTML" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
                </template>
                <!-- Widget Shipping next (possible) Day -->
                <template v-else-if="(countdown <= 0 || sunday || holiday || currentDay == 6 && !saturdayWeekday) && showShippingTimeHtmlNoShippingToday">
                    <div :class="this.$attrs.spacingclasses" v-html="updatedHTMLNo" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
                </template>
            </div>

            <!-- Shopbuilder -->
            <code style="font-size:75%!important;padding-bottom:10px;display:block" v-if="$ceres.isShopBuilder && showShopBuilderInfo">Vorschau!<template v-if="countdown < 0"> Negativer Countdown nur im Shopbuilder!</template></code>
            <div :class="'bg-' + appearance" v-if="$ceres.isShopBuilder" :style="roundedCorners ? { borderRadius: roundedCornersValue + 'px'} : {}">
                <div v-if="isNaN(parseFloat(countdown))" :class="this.$attrs.spacingclasses" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin">{{ $translate("DeliveryTimeWidget::Template.notValid") }}</div>
                <div v-else :class="this.$attrs.spacingclasses" v-html="updatedHTML" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
            </div>
            <hr v-if="$ceres.isShopBuilder && !showShopBuilderInfo && showShippingTimeHtmlNoShippingToday">
            <code style="font-size:75%!important;padding-bottom:10px;display:block;padding-top:10px" v-if="$ceres.isShopBuilder && showShippingTimeHtmlNoShippingToday && showShopBuilderInfo">Vorschau bei Versand am nächstmöglichen Tag:</code>
            <div :class="'bg-' + appearance" v-if="$ceres.isShopBuilder && showShippingTimeHtmlNoShippingToday" :style="roundedCorners ? { borderRadius: roundedCornersValue + 'px'} : {}">
                <div v-if="isNaN(parseFloat(countdown))" :class="this.$attrs.spacingclasses" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin">{{ $translate("DeliveryTimeWidget::Template.notValid") }}</div>
                <div v-else :class="this.$attrs.spacingclasses" v-html="updatedHTMLNo" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    // add leading zero in countdown
    function pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    }

    export default {
        data: function() {
            return {
                currentYear: dayjs().year(),
                currentDay: dayjs().get('day'),
                feiertage: [],
                updatedHTML: this.shippingTimeHtml,
                updatedHTMLNo: this.shippingTimeHtmlNoShippingToday,
                countdown: false,
                countdownHour: false,
                countdownMinute: false,
                placeholderCountdown: "",
                checkAvailibilityID: [],
                interval: null,
                saturdayWeekday: false,
                sunday: false,
                holiday: false,
                nextShippingDay: ""
            }
        },
        props: {
            shippingTimeState: null,
            appearance: null,
            roundedCorners: null,
            roundedCornersValue: null,
            placeholderTime: null,
            shippingTimeVisibility: null,
            shippingTimeSaturday: false,
            shippingTimeHtml: null,
            showShippingTimeHtmlNoShippingToday: true,
            shippingTimeHtmlNoShippingToday: null,
            useCss: null,
            useCssValue: null,
            showShopBuilderInfo: null
        },
        inject: {
            itemId: {
                default: null
            }
        },
        computed: {
            currentVariation() {
                return this.$store.getters[`${this.itemId}/currentItemVariation`]
            }
        },
        mounted() {
            var self = this;

            // availability ids (string) to array
            var av = this.shippingTimeVisibility.split(',').map(Number);
            this.checkAvailibilityID = av;

            // update widget every minute
            this.interval = setInterval(() => {
                this.updateWidget();
            }, 60000);

            this.fetchHolidays(this.currentYear);
        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        methods: {
            fetchHolidays(year) {
                var self = this;
                $.getJSON('https://feiertage-api.de/api/?jahr=' + year + '&nur_land=' + this.shippingTimeState).done(function(data) {
                    if (!self._isDestroyed) {
                        var feiertage = [];
                        for (var i = 0; i < Object.values(data).length; i++) {
                            feiertage.push(Object.values(data)[i].datum);
                        }
                        self.feiertage = feiertage;

                        // wait for feiertage render to settle before updating widget
                        self.$nextTick(() => {
                            self.updateWidget();
                        });
                    }
                });
            },
            updateWidget() {
                // check DST (Daylight Saving Time)
                Date.prototype.stdTimezoneOffset = function () {
                    var jan = new Date(this.getFullYear(), 0, 1);
                    var jul = new Date(this.getFullYear(), 6, 1);
                    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
                }

                Date.prototype.isDstObserved = function () {
                    return this.getTimezoneOffset() < this.stdTimezoneOffset();
                }

                const now = dayjs();

                // recalculate current day and year on every tick
                this.currentDay = now.get('day');
                const newYear = now.year();

                // re-fetch holidays if the year has rolled over
                if (newYear !== this.currentYear) {
                    this.currentYear = newYear;
                    this.fetchHolidays(newYear);
                    return; // updateWidget will be called again after fetchHolidays completes
                }

                var today = new Date();
                if (today.isDstObserved()) {
                    var ship = now.format('YYYY-MM-DD' + 'T' + this.placeholderTime);
                } else {
                    var ship = now.format('YYYY-MM-DD' + 'T' + this.placeholderTime + ':00+01:00');
                }

                var hour = this.$translate("DeliveryTimeWidget::Template.hour"),
                    minutes = this.$translate("DeliveryTimeWidget::Template.minutes"),
                    minute = this.$translate("DeliveryTimeWidget::Template.minute");

                var diffHour = now.diff(dayjs(ship), 'hour') * -1,
                    diffMinute = now.diff(dayjs(ship), 'minute') * -1,
                    countdownMinute = diffMinute - (diffHour * 60);

                // back to init for placeholder replacement
                this.updatedHTML = this.shippingTimeHtml;
                this.updatedHTMLNo = this.shippingTimeHtmlNoShippingToday;

                // calculate time differences
                this.countdown = diffMinute;
                this.countdownHour = diffHour;
                this.countdownMinute = countdownMinute;

                // show only minutes if less than 1 hour remains
                if (diffHour == '00' && App.language == "de") {
                    if (countdownMinute == 1) {
                        this.placeholderCountdown = countdownMinute + minute;
                    } else {
                        this.placeholderCountdown = countdownMinute + minutes;
                    }
                } else {
                    this.placeholderCountdown = diffHour + ":" + pad(countdownMinute, 2) + hour;
                }

                // replace placeholders
                this.updatedHTML = this.updatedHTML.replace(/%time/g, this.placeholderTime);
                this.updatedHTML = this.updatedHTML.replace(/%countdown/g, this.placeholderCountdown);

                // reset flags on every tick so they don't get permanently stuck
                this.sunday = this.currentDay == 0;
                this.holiday = this.feiertage.includes(now.format('YYYY-MM-DD'));
                this.saturdayWeekday = this.currentDay == 6 && this.shippingTimeSaturday;

                // calculate next shipping day
                let i = 0;

                if (this.shippingTimeSaturday) {
                    do {
                        i += 1;
                        this.nextShippingDay = now.add(i, 'day').format('YYYY-MM-DD');
                    } while (!(dayjs(this.nextShippingDay).get('day') != 0 && !this.feiertage.includes(this.nextShippingDay)));
                } else {
                    do {
                        i += 1;
                        this.nextShippingDay = now.add(i, 'day').format('YYYY-MM-DD');
                    } while (!(dayjs(this.nextShippingDay).get('day') != 6 && dayjs(this.nextShippingDay).get('day') != 0 && !this.feiertage.includes(this.nextShippingDay)));
                }

                // translate number day to human language
                var Weekdays = [
                    this.$translate("DeliveryTimeWidget::Template.day0"),
                    this.$translate("DeliveryTimeWidget::Template.day1"),
                    this.$translate("DeliveryTimeWidget::Template.day2"),
                    this.$translate("DeliveryTimeWidget::Template.day3"),
                    this.$translate("DeliveryTimeWidget::Template.day4"),
                    this.$translate("DeliveryTimeWidget::Template.day5"),
                    this.$translate("DeliveryTimeWidget::Template.day6")
                ];

                // handling tomorrow wording
                if (now.get('day') + 1 == dayjs(this.nextShippingDay).get('day')) {
                    this.updatedHTMLNo = this.updatedHTMLNo.replace(/%day/g, this.$translate("DeliveryTimeWidget::Template.tomorrow"));
                } else {
                    this.updatedHTMLNo = this.updatedHTMLNo.replace(/%day/g, Weekdays[dayjs(this.nextShippingDay).get('day')]);
                }
            }
        }
    }
</script>
